import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { BaseCoreState, baseAdministrationActions, baseAdministrationSelectors } from 'base';

@Injectable({ providedIn: 'root' })
export class BaseCustomerCustomerDataGuard implements CanActivate {
  constructor(private readonly store: Store<BaseCoreState>) {}

  canActivate() {
    return this.check$();
  }

  private check$(): Observable<boolean | UrlTree> {
    return this.store.select(baseAdministrationSelectors.getCustomerData).pipe(
      take(1),
      tap((state) => {
        if (state.ok === undefined && !state.data) {
          this.store.dispatch(baseAdministrationActions.loadCustomerData());
        }
      }),
      switchMap(() =>
        this.store.select(baseAdministrationSelectors.getCustomerData).pipe(
          filter((state) => state.ok !== undefined),
          take(1),
          map((state) => !!state.ok)
        )
      )
    );
  }
}
